import { isEmpty } from '@ember/utils';
import dateUtils from 'donor-elf-web/lib/date-utils';
import { isNumber } from 'donor-elf-web/lib/string-utils';
import { assignSingleProperty } from 'donor-elf-web/lib/object-utils';
import { oneTimeGoalTypeId } from 'donor-elf-web/lib/journal-goal-utils';
import {
  validatePresence,
  validateNumber,
} from 'ember-changeset-validations/validators';

export default {
  startDate: (key, newValue, oldValue, changes, content) => {
    if (isEmpty(newValue)) {
      return "Start Date can't be blank";
    }
    if (
      dateUtils.serializeToDateOnly(newValue) >
      dateUtils.serializeToDateOnly(new Date())
    ) {
      return "Start Date can't be in the future";
    }
    let goalDate = assignSingleProperty(content, changes, 'goalDate');
    if (goalDate && goalDate <= newValue) {
      return 'Start Date has to be before Goal Date';
    }
    return true;
  },
  journalTemplateId: (_key, newValue, _oldValue, changes, content) => {
    let duplicateJournalId = assignSingleProperty(
      content,
      changes,
      'duplicateJournalId',
    );
    if (isEmpty(newValue) && isEmpty(duplicateJournalId)) {
      return "Journal Template can't be blank";
    }
    return true;
  },
  goalDate: validatePresence({
    presence: true,
    message: "Goal Date can't be blank",
  }),
  mainGoalTypeId: validatePresence({
    presence: true,
    message: "Goal Type can't be blank",
  }),
  mainGoalAmount: validateNumber({
    gt: 0,
    message: 'Goal Amount must be greater than 0',
  }),
  secondaryOneTimeGoalAmount: (key, newValue, oldValue, changes, content) => {
    let createSecondaryOneTimeGoal = assignSingleProperty(
      content,
      changes,
      'createSecondaryOneTimeGoal',
    );
    let mainGoalTypeId = assignSingleProperty(
      content,
      changes,
      'mainGoalTypeId',
    );
    if (
      createSecondaryOneTimeGoal &&
      mainGoalTypeId?.toString() !== oneTimeGoalTypeId.toString()
    ) {
      if (!isNumber(newValue) || Number(newValue) <= 0) {
        return 'One Time Goal Amount must be greater than 0';
      }
    }
    return true;
  },
};
